import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const presupuestoService = {
  getPresupuestoByIdArea,
  getPresupuestoById,
  aprobarPresupuesto,
  getPresupuestoByIdEmpresa,
  guardarPresupuesto,
  getPresupuestoByIdAreaTemporal,
  eliminarPresupuesto,
  getBalanceByIdPresupuesto,
  findByIdAreaFilter,
  resumenTipoGastoByIdPresupuesto,
  resumenMensualTipoGastoByIdPresupuesto,
  resumenMensualIngresoByIdPresupuesto,
}

async function getPresupuestoByIdArea(id) {
  return await ApiBudgety.get('Presupuesto/FindByIdArea/' + id)
}

async function getPresupuestoById(id) {
  return await ApiBudgety.get('Presupuesto/FindById/' + id)
}

async function aprobarPresupuesto(idusuario, id) {
  return await ApiBudgety.post('Presupuesto/AprobarById/' + idusuario + '/' + id, null, {
    headers: {
      ACCION: MenusSistema.presupuesto_asignado.accesos.aprobar_presupuesto,
      MENU: MenusSistema.presupuesto_asignado.id,
    },
  })
}

async function getPresupuestoByIdEmpresa(id, historico) {
  return await ApiBudgety.get('Presupuesto/FindByIdEmpresa/' + id + '/' + historico)
}

async function guardarPresupuesto(idusuario, presupuesto) {
  return await ApiBudgety.post('Presupuesto/InsertOrUpdate/' + idusuario, presupuesto, {
    headers: {
      ACCION: MenusSistema.presupuesto_listado.accesos.crear_editar_presupuesto,
      MENU: MenusSistema.presupuesto_listado.id,
    },
  })
}

async function getPresupuestoByIdAreaTemporal(id) {
  return await ApiBudgety.get('Presupuesto/FindByIdAreaTemporal/' + id)
}

async function eliminarPresupuesto(idusuario, presupuesto) {
  return await ApiBudgety.post('Presupuesto/Delete/' + idusuario, presupuesto, {
    headers: {
      ACCION: MenusSistema.presupuesto_listado.accesos.crear_editar_presupuesto,
      MENU: MenusSistema.presupuesto_listado.id,
    },
  })
}

async function getBalanceByIdPresupuesto(id) {
  return await ApiBudgety.get('Presupuesto/LoadBalanceById/' + id, {
    headers: {
      ACCION: MenusSistema.presupuesto_listado.accesos.ver_resumen,
      MENU: MenusSistema.presupuesto_listado.id,
    },
  })
}

async function findByIdAreaFilter(body) {
  return await ApiBudgety.post('Presupuesto/FindByIdAreaFilter/', body)
}

async function resumenTipoGastoByIdPresupuesto(id) {
  return await ApiBudgety.get('Presupuesto/ResumenTipoGastoByIdPresupuesto/' + id, {
    headers: {
      ACCION: MenusSistema.reporte_dashboard.accesos.ver_reporte,
      MENU: MenusSistema.reporte_dashboard.id,
    },
  })
}

async function resumenMensualTipoGastoByIdPresupuesto(id, anio) {
  return await ApiBudgety.get('Presupuesto/ResumenMensualTipoGastoByIdPresupuesto/' + id + '/' + anio, {
    headers: {
      ACCION: MenusSistema.reporte_dashboard.accesos.ver_reporte,
      MENU: MenusSistema.reporte_dashboard.id,
    },
  })
}

async function resumenMensualIngresoByIdPresupuesto(id, anio) {
  return await ApiBudgety.get('Presupuesto/ResumenMensualIngresoByIdPresupuesto/' + id + '/' + anio, {
    headers: {
      ACCION: MenusSistema.reporte_dashboard.accesos.ver_reporte,
      MENU: MenusSistema.reporte_dashboard.id,
    },
  })
}
